export default __webpack_public_path__ + "static/media/single-project-page-02-img13.bdfa0eec.jpg";